<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Supplier</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Supplier Name*</label>
            <v-text-field 
              required
              placeholder="Enter Supplier Name"
              v-model="supplier.name">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Description</label>
            <v-text-field 
              placeholder="Enter Supplier Description"
              v-model="supplier.desc">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Address*</label>
            <v-text-field 
              required
              placeholder="Enter Supplier Address"
              v-model="supplier.address">
            </v-text-field>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label">City*</label>
              <v-text-field 
                required
                placeholder="Enter Supplier City"
                v-model="supplier.city">
              </v-text-field>
            </div>
            <div class="column">
              <label class="label">Provice/State*</label>
              <v-text-field 
                required
                placeholder="Enter Supplier Province/State"
                v-model="supplier.province">
              </v-text-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <label class="label">Country*</label>
              <v-text-field 
                required
                placeholder="Enter Supplier Country"
                v-model="supplier.country">
              </v-text-field>
            </div>
            <div class="column">
              <label class="label">Postal Code*</label>
              <v-text-field 
                required
                placeholder="Enter Supplier Postal Code"
                v-model="supplier.postalcode">
              </v-text-field>
            </div>
          </div>
          
          <div class="field">
            <label class="label">Telephone*</label>
            <v-text-field 
              required
              placeholder="Enter Supplier Phone Number"
              v-model="supplier.phone1">
            </v-text-field>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { 
    VTextField, 
    VForm
  },
  data() {
    return {
      supplier: {
        name: null,
        desc: null,
        address: null,
        city: null,
        province: null,
        country: null,
        postalcode: null,
        phone1: null
      },
      valid: false
    }
  },
  methods: {
    ...mapActions("suppliers", ["addSupplier"]),
    addNew() {
      this.addSupplier({ 
        data: this.supplier
      }).then(() => {
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
